import React from 'react';
import { FileIcon, EyeIcon, DownloadIcon } from 'lucide-react';
import { Document, Folder } from '../types/documents';
interface DocumentRowProps {
  document: Document;
  onView: (doc: Document) => void;
  isNested?: boolean;
  folders?: Folder[];
  onMoveDocument?: (docId: string, folderId: string | undefined) => void;
}
export function DocumentRow({
  document,
  onView,
  isNested = false,
  folders = [],
  onMoveDocument
}: DocumentRowProps) {
  return <div className={`group flex items-center justify-between py-3 pr-6 border-b border-[#DDDBDA] hover:bg-[#F3F3F3] transition-colors duration-200 ${isNested ? 'pl-12 bg-[#FAFAF9]' : 'pl-6 bg-white'}`} data-id="element-63">
      <div className="flex items-start space-x-4 flex-1 min-w-0" data-id="element-64">
        <div className="flex-shrink-0 mt-1" data-id="element-65">
          <div className="w-8 h-10 bg-[#E3F2FD] rounded flex items-center justify-center border border-[#0176D3]/20" data-id="element-66">
            <FileIcon className="w-5 h-5 text-[#0176D3]" aria-hidden="true" data-id="element-67" />
          </div>
        </div>
        <div className="flex flex-col min-w-0 flex-1" data-id="element-68">
          <h4 className="text-sm font-semibold text-[#0176D3] truncate group-hover:underline cursor-pointer" onClick={() => onView(document)} data-id="element-69">
            {document.name}
          </h4>
          <div className="flex items-center text-xs text-[#706E6B] mt-1 space-x-2" data-id="element-70">
            <span data-id="element-71">{document.type}</span>
            <span data-id="element-72">&bull;</span>
            <span data-id="element-73">{document.date}</span>
            <span data-id="element-74">&bull;</span>
            <span data-id="element-75">{document.size}</span>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-2 ml-4 flex-shrink-0" data-id="element-76">
        {onMoveDocument && folders.length > 0 && <div className="mr-2" data-id="element-77">
            <select value={document.folderId || ''} onChange={e => onMoveDocument(document.id, e.target.value || undefined)} className="block w-full pl-3 pr-8 py-1.5 text-xs border border-[#DDDBDA] rounded bg-white text-[#444444] focus:outline-none focus:ring-1 focus:ring-[#0176D3] focus:border-[#0176D3] transition-colors cursor-pointer" aria-label={`Move ${document.name} to folder`} data-id="element-78">
              <option value="" data-id="element-79">No Folder</option>
              {folders.map(folder => <option key={folder.id} value={folder.id} data-id="element-80">
                  {folder.name}
                </option>)}
            </select>
          </div>}

        <button className="flex items-center justify-center px-3 py-1.5 text-sm font-medium text-[#444444] bg-white border border-[#DDDBDA] rounded hover:bg-[#ECEBEA] focus:outline-none focus:ring-2 focus:ring-[#0176D3] focus:ring-offset-1 transition-colors" aria-label={`Download ${document.name}`} data-id="element-81">
          <DownloadIcon className="w-4 h-4 mr-1.5" aria-hidden="true" data-id="element-82" />
          Download
        </button>
        <button onClick={() => onView(document)} className="flex items-center justify-center px-3 py-1.5 text-sm font-medium text-[#0176D3] bg-white border border-[#DDDBDA] rounded hover:bg-[#ECEBEA] focus:outline-none focus:ring-2 focus:ring-[#0176D3] focus:ring-offset-1 transition-colors" aria-label={`View ${document.name}`} data-id="element-83">
          <EyeIcon className="w-4 h-4 mr-1.5" aria-hidden="true" data-id="element-84" />
          View
        </button>
      </div>
    </div>;
}